<template>
   <div>
       <page-header :title="$t('live.page_title')" icon-class="mdi mdi-record-circle-outline"/>

       <div v-if="$store.getters.isLiveStreamOnline">
           <div class="row mb-3" v-if="!$store.getters.isExecutingRequest">
               <div class="col-md-12">
                   <div class="vjs-responsive">
                       <video-player
                           :options="playerOptions"
                           class="vjs-custom-skin"
                           ref="videoPlayer"
                           @ready="playerReadied"
                       >
                       </video-player>
                   </div>
               </div>
           </div>
       </div>
       <div v-else>
           <div class="row">
               <div class="col-md-12">
                   <div class="card shadow-sm">
                       <div class="card-body text-center">
                           <i class="mdi mdi-record-circle-outline text-muted mdi-96px"></i>
                           <h2 class="font-weight-lighter mt-3" v-html="$t('live.offline')"></h2>
                       </div>
                   </div>
               </div>
           </div>
       </div>
   </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import PageHeader from "../Includes/PageHeader";

export default {
    name: "DisplayLivestream",
    components: {PageHeader, videoPlayer},
    data: () => ({
        playerOptions: {
            sources: [{
                type: 'application/x-mpegURL',
                src: process.env.MIX_STREAM_SERVER_URL
            }],
            muted: false,
            autoplay: true,
            fluid: true,
        },
    }),
    mounted() {
    },
    methods: {
        playerReadied() {

        },
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
    }
}
</script>

<style scoped>

</style>
